import { Link, Typography, TypographyProps } from "@mui/material";

const Copyright = (props: Partial<TypographyProps>) => {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {"Copyright © "}
      <Link color="inherit" href="https://canna42.com/">
        canna42.com
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

export default Copyright;
